import React, { Component } from "react";
import { connect } from "react-redux";
import { Input, FormFeedback } from "reactstrap";

import api from "../../config/api";
import historyAction from "../../redux/history/action";
import mpAction from "../../redux/microPensionDublicated/action";
import InputComp from "../../component/InputComp/InputComp";

class Employer extends Component {
  state = {
    allStates: [],
    allLGA: [],
  };

  componentDidMount() {
    const { customRef } = this.props;

    this.fetchState(null, true);

    customRef({ validate: this.validate });
  }

  onSelectChange = (e) => {
    const { setNextOfKinField } = this.props;

    setNextOfKinField({ [e.target.name]: e.target.value });

    if (e.target.name === "nokStatecode") {
      this.fetchLGA(e.target.value);
    }
  };

  fetchState = async (nokCountry, dontClear) => {
    try {
      const { user, setNextOfKinField, nokStatecode } = this.props;

      if (!dontClear) {
        setNextOfKinField({
          nokStatecode: "",
          nokLga: "",
        });
      }

      this.setState({ allStates: [], allLGA: [] });

      if (!nokCountry) {
        nokCountry = this.props.nokCountry;
      }

      if (nokCountry === "N") {
        nokCountry = "NG";
      }

      if (nokStatecode) {
        this.fetchLGA(null, true);
      }

      const state = await api.fetchState(
        { countryCode: nokCountry },
        user.token
      );

      this.setState({ allStates: state.data.result });
    } catch (e) {
      console.log("E =>", e);
    }
  };

  fetchLGA = async (nokStatecode, dontClear) => {
    try {
      const { user, setNextOfKinField } = this.props;

      if (!dontClear) {
        setNextOfKinField({ nokLga: "" });
      }

      this.setState({ allLGA: [] });

      if (!nokStatecode) {
        nokStatecode = this.props.nokStatecode;
      }

      const LGA = await api.fetchLGA({ stateCode: nokStatecode }, user.token);

      this.setState({ allLGA: LGA.data.result });
    } catch (e) {
      console.log("E =>", e);
    }
  };

  validate = () => {
    const {
      nokMobilePhone,
      nokResidenceHouseNumber,
      nokTitle,
      // nokResidenceStreetName,
      nokName,
      nokSurname,
      nokGender,
      nokRelationship,
      nokStatecode,
      nokLga,
      nokLocation,
      nokCountry,
      // nokEmailaddress,
      // nokOthername
      nokCity
    } = this.props;

    let isValidated = true,
      nokMobilePhoneError,
      nokResidenceHouseNumberError,
      // nokResidenceStreetNameError,
      nokTitleError,
      nokNameError,
      nokSurnameError,
      nokGenderError,
      nokRelationshipError,
      nokStatecodeError,
      nokLgaError,
      nokLocationError,
      nokCountryError,
      nokEmailaddressError,
      nokOthernameError,
      nokCityError;

    if (nokMobilePhone.length !== 11) {
      nokMobilePhoneError = "Phone number should be 11 digits";
      isValidated = false;
    }
    if (!nokCountry) {
      nokCountryError = "This field is required";
      isValidated = false;
    }

    if (!nokResidenceHouseNumber) {
      nokResidenceHouseNumberError = "This field is required";
      isValidated = false;
    }
    // if (nokLocation === "N" && !nokCity) {
    //   nokCityError = "This field is required";
    //   isValidated = false;
    // }
    // if (!nokResidenceStreetName) {
    //   nokResidenceStreetNameError = "This field is required";
    //   isValidated = false;
    // }
    if (!nokTitle) {
      nokTitleError = "This field is required";
      isValidated = false;
    }
    if (!nokName) {
      nokNameError = "This field is required";
      isValidated = false;
    }
    if (!nokSurname) {
      nokSurnameError = "This field is required";
      isValidated = false;
    }
    if (!nokGender) {
      nokGenderError = "This field is required";
      isValidated = false;
    }

    if (!nokRelationship) {
      nokRelationshipError = "This field is required";
      isValidated = false;
    }

    if (!nokCity) {
      nokCityError = "This field is required";
      isValidated = false;
    }

    if (nokLocation === "N" && !nokStatecode) {
      nokStatecodeError = "This field is required";
      isValidated = false;
    }

    if (nokLocation === "N" && !nokLga) {
      nokLgaError = "This field is required";
      isValidated = false;
    }

    if (!nokLocation) {
      nokLocationError = "This field is required";
      isValidated = false;
    }

    // if (!nokEmailaddress) {
    //   nokEmailaddressError = "This field is required";
    //   isValidated = false;
    // }

    // if (!nokOthername) {
    //   nokOthernameError = "This field is required";
    //   isValidated = false;
    // }

    this.setState({
      nokMobilePhoneError,
      nokResidenceHouseNumberError,
      // nokResidenceStreetNameError,
      nokTitleError,
      nokNameError,
      nokSurnameError,
      nokGenderError,
      nokRelationshipError,
      nokStatecodeError,
      nokLgaError,
      nokLocationError,
      nokCountryError,
      nokEmailaddressError,
      nokOthernameError,
      nokCityError
    });

    return isValidated;
  };

  render() {
    const {
      nokEmailaddress,
      setNextOfKinField,
      nokName,
      nokGender,
      nokOthername,
      nokLocation,
      nokMobilePhone,
      nokBox,
      nokRelationship,
      nokCountry,
      nokAddress,
      nokAddress1,
      nokLga,
      nokStatecode,
      // nokResidenceStreetName,
      nokCity,
      nokSurname,
      nokTitle,
      nokZip,
      countries,
      // nokOthername,
      allRelationShips,
      nokResidenceHouseNumber,
    } = this.props;

    const {
      allLGA,
      allStates,
      nokMobilePhoneError,
      nokResidenceHouseNumberError,
      // nokResidenceStreetNameError,
      nokTitleError,
      nokNameError,
      nokSurnameError,
      nokGenderError,
      nokRelationshipError,
      nokLgaError,
      nokStatecodeError,
      nokLocationError,
      nokCountryError,
      nokOthernameError,
      nokEmailaddressError,
      nokCityError
    } = this.state;

    return (
      <div>
        <Input
          className="margin-y-10"
          type="select"
          name="nokTitle"
          value={nokTitle || "placeholder"}
          invalid={!!nokTitleError}
          onChange={this.onSelectChange}
        >
          <option value="placeholder" selected disabled>
            Title*
          </option>
          <option value="Mr">Mr</option>
          <option value="Mrs">Mrs</option>
          <option value="Miss">Miss</option>
          <option value="Ms">Ms</option>
        </Input>
        {!!nokTitleError && (
          <FormFeedback invalid>{nokTitleError}</FormFeedback>
        )}
        <InputComp
          type="text"
          value={nokName}
          placeholder="NOK First Name"
          errorMessage={nokNameError}
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setNextOfKinField({ nokName: e.target.value });
          }}
        />
        <InputComp
          type="text"
          value={nokOthername}
          placeholder="NOK Middle Name"
          errorMessage={nokOthernameError}
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setNextOfKinField({ nokOthername: e.target.value });
          }}
        />
        <InputComp
          type="text"
          value={nokSurname}
          placeholder="NOK Surname"
          errorMessage={nokSurnameError}
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setNextOfKinField({ nokSurname: e.target.value });
          }}
        />

        {/* <InputComp
          type="text"
          value={nokOthername}
          placeholder="Next of Kin OtherName"
          containerStyles={{ width: "100%" }}
          onChange={e => {
            setNextOfKinField({ nokOthername: e.target.value });
          }}
        /> */}

        <Input
          className="margin-y-10"
          type="select"
          name="nokGender"
          id="exampleSelect"
          value={nokGender || "placeholder"}
          onChange={this.onSelectChange}
          invalid={!!nokGenderError}
        >
          <option value="placeholder" selected disabled>
            Gender*
          </option>
          <option value="M">Male</option>
          <option value="F">Female</option>
        </Input>
        {!!nokGenderError && (
          <FormFeedback invalid>{nokTitleError}</FormFeedback>
        )}

        <Input
          className="margin-y-10"
          type="select"
          name="nokCountry"
          invalid={!!nokCountryError}
          id="exampleSelect"
          value={nokCountry || "placeholder"}
          onChange={this.onSelectChange}
        >
          <option value="placeholder" disabled selected>
            Next Of Kin Country
          </option>
          {countries.map((item) => (
            <option key={Math.random().toString()} value={item.countryCode}>
              {item.countryName}
            </option>
          ))}
        </Input>
        {!!nokCountryError && (
          <FormFeedback invalid>{nokCountryError}</FormFeedback>
        )}
        <InputComp
          type="text"
          value={nokMobilePhone}
          placeholder="Next of Kin Mobile Phone"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setNextOfKinField({ nokMobilePhone: e.target.value });
          }}
          errorMessage={nokMobilePhoneError}
        />
        <Input
          className="margin-y-10"
          type="select"
          name="nokRelationship"
          invalid={!!nokRelationshipError}
          value={nokRelationship || "placeholder"}
          onChange={this.onSelectChange}
        >
          <option value="placeholder" disabled selected>
            NOK Relationship*
          </option>
          {allRelationShips.map((item) => (
            <option key={Math.random().toString()} value={item}>
              {item}
            </option>
          ))}
        </Input>

        {/* <InputComp
          type="text"
          value={nokRelationship}
          placeholder="NOK Relationship"
          errorMessage={nokRelationshipError}
          containerStyles={{ width: "100%" }}
          onChange={e => {
            setNextOfKinField({ nokRelationship: e.target.value });
          }}
        /> */}
        <InputComp
          type="text"
          value={nokEmailaddress}
          placeholder="Next of Kin Email"
          errorMessage={nokEmailaddressError}
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setNextOfKinField({ nokEmailaddress: e.target.value });
          }}
        />

        <Input
          className="margin-y-10"
          type="select"
          invalid={!!nokLocationError}
          name="nokLocation"
          id="exampleSelect"
          value={nokLocation || "placeholder"}
          onChange={(e) => {
            setNextOfKinField({ nokLocation: e.target.value });
            this.fetchState(e.target.value);
          }}
        >
          <option value="placeholder" disabled selected>
            Next of Kin Location *
          </option>
          <option value="N">Nigeria</option>
          <option value="A">Abroad</option>
        </Input>
        {!!nokLocationError && (
          <FormFeedback invalid>{nokLocationError}</FormFeedback>
        )}
        <InputComp
          type="text"
          value={nokAddress1}
          placeholder="Next of Kin Address"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setNextOfKinField({ nokAddress1: e.target.value });
          }}
        />
        <InputComp
          type="text"
          value={nokAddress}
          placeholder="Next of Kin Additional Address"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setNextOfKinField({ nokAddress: e.target.value });
          }}
        />
        <InputComp
          type="text"
          value={nokResidenceHouseNumber}
          placeholder="NOK Residence House Number *"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setNextOfKinField({ nokResidenceHouseNumber: e.target.value });
          }}
          errorMessage={nokResidenceHouseNumberError}
        />
        {/* <InputComp
          type="text"
          value={nokResidenceStreetName}
          placeholder="NOK Residence Street Name"
          containerStyles={{ width: "100%" }}
          onChange={e => {
            setNextOfKinField({ nokResidenceStreetName: e.target.value });
          }}
          errorMessage={nokResidenceStreetNameError}
        /> */}
        <InputComp
          type="text"
          value={nokCity}
          placeholder="Next of Kin City *"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setNextOfKinField({ nokCity: e.target.value });
          }}
          errorMessage={nokCityError}
        />
        <Input
          className="margin-y-10"
          type="select"
          name="nokStatecode"
          id="exampleSelect"
          invalid={!!nokStatecodeError}
          value={nokStatecode || "placeholder"}
          onChange={this.onSelectChange}
        >
          <option value="placeholder" disabled selected>
            NOK Residence State Code*
          </option>
          {allStates.map((item) => (
            <option key={Math.random().toString()} value={item.stateCode}>
              {item.stateName}
            </option>
          ))}
        </Input>
        {!!nokStatecodeError && (
          <FormFeedback invalid>{nokStatecodeError}</FormFeedback>
        )}
        <Input
          className="margin-y-10"
          type="select"
          name="nokLga"
          invalid={!!nokLgaError}
          id="exampleSelect"
          value={nokLga || "placeholder"}
          onChange={this.onSelectChange}
        >
          <option value="placeholder" disabled selected>
            Next of Kin Local Govt*
          </option>
          {allLGA.map((item) => (
            <option key={Math.random().toString()} value={item.lgaCode}>
              {item.lgaName}
            </option>
          ))}
        </Input>
        {!!nokLgaError && <FormFeedback invalid>{nokLgaError}</FormFeedback>}
        <InputComp
          type="text"
          value={nokBox}
          placeholder="Next of Kin P.O.Box"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setNextOfKinField({ nokBox: e.target.value });
          }}
        />
        <InputComp
          type="text"
          value={nokZip}
          placeholder="Next of Zip"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setNextOfKinField({ nokZip: e.target.value });
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  ...state.microPensionDublicated.nextOfKin,
  countries: state.onboarding.countries,
  allRelationShips: state.auth.relationShips,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setNextOfKinField: mpAction.setNextOfKinField,
};

export default connect(mapStateToProps, mapDispatchToProps)(Employer);
